import { render, staticRenderFns } from "./HosIndex.vue?vue&type=template&id=80fd53ca&"
import script from "./HosIndex.vue?vue&type=script&lang=js&"
export * from "./HosIndex.vue?vue&type=script&lang=js&"
import style0 from "./HosIndex.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports